//@flow

import {buildRoute} from '../../../http';
import {
  endpoints,
  createBannerCollectionApi,
  updateBannerCollectionApi,
  getBannerCollectionApi,
  deleteBannerCollectionApi,
} from '../api/banner-collections';

import type {BannerCollection} from '../../../entities';

export type StoreReferenceEntity = {
  storeReferenceEntityType: 'PRODUCT' | 'CATEGORY',
  storeReferenceEntityIdentifier: string,
};

export type CreateBannerCollectionRequest = {
  name: string,
  slug: string,
  storeReferenceEntities: StoreReferenceEntity[],
};
export function createBannerCollectionService(
  payload: CreateBannerCollectionRequest
): Promise<BannerCollection> {
  return createBannerCollectionApi(payload).toPromise();
}

export type UpdateBannerCollectionRequest = {
  name?: string,
  slug?: string,
  storeReferenceEntities?: StoreReferenceEntity[],
};

export function updateBannerCollectionService(
  collectionId: string,
  payload: UpdateBannerCollectionRequest
): Promise<BannerCollection> {
  const route = buildRoute(endpoints.UPDATE_BANNER_COLLECTION, [collectionId]);

  return updateBannerCollectionApi(payload, {route}).toPromise();
}

export function getBannerCollectionService(
  collectionId: string
): Promise<BannerCollection> {
  const route = buildRoute(endpoints.UPDATE_BANNER_COLLECTION, [collectionId]);
  return getBannerCollectionApi(undefined, {
    route,
  }).toPromise();
}

export function deleteBannerCollectionService(collectionId: string) {
  const route = buildRoute(endpoints.DELETE_BANNER_COLLECTION, [collectionId]);
  return deleteBannerCollectionApi({
    route,
  }).toPromise();
}
